<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select
        @changeDateFormatData="changeDateFormatData($event.dateFormatId)"
        :isMonthly="true"
      />
      <search-channel-select v-model="tableParams.channelId" />
      <search-channel-slot-select
        v-model="slotIdList"
        :channel-id="tableParams.channelId"
        multiple
      />
      <search-dsp-select v-model="tableParams.dspId" />

      <search-dsp-slot-select
        v-model="dspSlotIdList"
        :dsp-id="tableParams.dspId"
        multiple
      />

      <search-slot-type-select v-model="tableParams.slotTypeId" />
      <search-budget-type v-model="tableParams.budget" />
      <el-select
        v-model="tableParams.appType"
        clearable
        placeholder="请选择设备类型"

      >
        <el-option label="Android" :value="1"></el-option>
        <el-option label="ios " :value="2"></el-option>
        <el-option label="鸿蒙" :value="3"></el-option>
        <el-option label="其他" :value="4"></el-option>
      </el-select>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        :hide="hides"
        table-id="channelReport"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel('/report/channel/list/csv', '渠道报表', tableParams)
          "
          type="warning"
          size="small"
          >下载</el-button
        >
        <el-button @click="down" type="warning" size="small"
          >下载明细</el-button
        >
        <el-button @click="inspectDau" type="warning" size="small"
          >检查dau</el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        @sort-change="sortChange"
        @selection-change="selectionChange"
        :header-cell-style="{ background: '#fafafa' }"
        :load="load"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        row-key="id"
        lazy
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        size="small"
        ref="report"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="handleDisable"
        >
        </el-table-column>

        <el-table-column
          v-if="
            tableParams.isDay === 1 ||
            tableParams.isHour === 1 ||
            tableParams.isMonth === 1
          "
          prop="reportTime"
          :label="
            tableParams.isDay === 1 || tableParams.isMonth === 1
              ? '日期'
              : '时间'
          "
          fixed
          sortable
          align="center"
        />
        <el-table-column
          v-for="(v, i) in checkColumns"
          align="center"
          :prop="v.field"
          :sortable="
            v.field === 'uniShowSmt' ||
            v.field === 'uniClkSmt' ||
            v.field === 'reqSmt' ||
            v.field === 'dauSlotReqSmt' ||
            v.field === 'time' ||
            v.field === 'effectiveFillingRate' ||
            v.field === 'effectiveShowRat' ||
            v.field === 'repSmt' ||
            v.field === 'showRat' ||
            v.field === 'fillingRate' ||
            v.field === 'clickRate' ||
            v.field === 'dpRate' ||
            v.field === 'dpSmt' ||
            v.field === 'resSmt' ||
            v.field === 'uniWinSmt' ||
            v.field === 'bidPrice' ||
            v.field === 'basePrice' ||
            v.field === 'bidDspPrice' ||
            v.field === 'channelEcpm' ||
            v.field === 'ecpmAverage' ||
            v.field === 'realBidPrice' ||
            v.field === 'auctionPrice' ||
            v.field === 'profit' ||
            v.field === 'winPrice' ||
            v.field === 'cpcPrice' ||
            v.field === 'cpvAverage' ||
            v.field === 'profitRate' ||
            v.field === 'reportTime' ||
            v.field === 'effectiveResSmt'
          "
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
        >
          <template v-slot="scope">
            <el-tag
              v-if="
                v.field === 'deeplinkNumberProportion' ||
                v.field === 'timeoutNumberProportion'
              "
              type="info"
              >{{ scope.row[v.field] }}</el-tag
            >
            <el-tag
              v-else-if="
                v.field === 'showRat' ||
                v.field === 'clickRate' ||
                v.field === 'dpRate' ||
                v.field === 'profitRate' ||
                v.field === 'fillingRate' ||
                v.field === 'effectiveFillingRate' ||
                v.field === 'effectiveShowRat' ||
                v.field === 'bidRate'
              "
              type="info"
              >{{ scope.row[v.field] }}%</el-tag
            >

            <span v-else style="display: inline-block">{{
              scope.row[v.field]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图表">
          <template v-slot="scope" align="center">
            <el-button
              size="mini"
              @click="openMyEchart(scope.row)"
              :disabled="scope.row['appId']"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60, 100, 200]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      @close="close"
      width="60%"
      :title="chartParam.title"
      append-to-body
    >
      <div>
        <el-radio-group v-model="chartTimeRadio" @change="changeChartTimeRadio">
          <el-radio-button label="最近3天"></el-radio-button>
          <el-radio-button label="最近7天"></el-radio-button>
          <el-radio-button label="最近15天"></el-radio-button>
          <el-radio-button label="本月"></el-radio-button>
          <el-radio-button label="上月"></el-radio-button>
        </el-radio-group>
        <div style="float: right">
          <base-date-picker :default-date="this.chartParam.defaultDate " @changeDate="changeChartDate"/>
          <el-checkbox v-model="this.checked" >对比</el-checkbox>
          <base-date-picker v-if="this.checked" :default-date="this.chartParam.defaultDate " @changeDate="changeChartDate2" style="margin-left: 15px"/>
        </div>

        <echart-time-comparison :listData="listData" title="时段对比"/>
      </div>

    </el-dialog>
    <el-dialog
      v-model="checkDialog"
      :close-on-click-modal="false"
      @close="closeCheckDialog"
      width="50%"
      append-to-body
    >
      <div>
        <div>
          日期:{{ this.tableParams.startTime }}-{{ this.tableParams.endTime }}
        </div>
        <div
          v-for="(item, index) in checkDauData.slotDauNumList"
          :key="item.slotId"
          style="padding: 10px"
        >
          <span style="margin-right: 10px">广告位:{{ item.slotName }},</span
          ><span>dau: {{ item.dauNum }}</span>
        </div>
        <div>合并后dau数为:{{ checkDauData.sumDauNum }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DateFormatSelect from "@/components/DateFormatSelect";
import SearchChannelSelect from "@/components/SearchChannelSelect";
import SearchDspSlotSelect from "@/components/SearchDspSlotSelect";
import SearchDspSelect from "@/components/SearchDspSelect";
import SearchChannelSlotSelect from "@/components/SearchChannelSlotSelect";
import SearchSlotTypeSelect from "@/components/SearchSlotTypeSelect";
import BaseDatePicker from "@/components/BaseDatePicker";
import TableColumn from "@/components/TableColumn";
import SearchBudgetType from "@/components/SearchBudgetType";
import {
  getChannelDetailReportList,
  getChanneltList,
  dauInspect,
} from "@/api/report/channel";
import initTableMixin from "@/mixins/initTable";
import downExcelMixin from "@/mixins/downExcel";
import myEchart from "@/components/myEchart";

import { uuid } from "@/util/util";
import {getDspEchartTimeReportList} from "@/api/manage/dsp/dsp";
import EchartTimeComparison from "@/components/EchartTimeComparison/index.vue";

export default {
  name: "Channel",
  components: {
    DateFormatSelect,
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    SearchChannelSlotSelect,
    SearchSlotTypeSelect,
    BaseDatePicker,
    TableColumn,
    EchartTimeComparison,
    SearchBudgetType,
    myEchart,
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: "channelName", title: "渠道名称" },
        { field: "dspName", title: "DSP名称" },
        { field: "slotId", title: "广告位编号" },
        { field: "slotName", title: "广告位名称" },
        { field: "reqSmt", title: "请求数" },
        { field: "realDauSmt", title: "真实DAU" },
        { field: "dauSlotReqSmt", title: "请求dau" },
        { field: "resSmt", title: "填充数" },
        { field: "effectiveResSmt", title: "有效填充" },
        { field: "fillingRate", title: "填充率" },
        { field: "effectiveFillingRate", title: "有效填充率" },
        { field: "uniShowSmt", title: "展示数" },
        { field: "showRat", title: "展示率" },
        { field: "effectiveShowRat", title: "有效展示率" },
        { field: "uniClkSmt", title: "点击数" },
        { field: "clickRate", title: "点击率" },
        { field: "deeplinkNumberProportion", title: "dp填充率" },
        { field: "timeoutNumberProportion", title: "超时率" },
        { field: "dpRate", title: "dp唤起率" },
        { field: "cpcPrice", title: "CPC单价" },
        { field: "auctionPrice", title: "支出" },
        { field: "channelEcpm", title: "支出ecpm" },
        { field: "winPrice", title: "收入" },
        { field: "ecpmAverage", title: "收入ecpm" },
        { field: 'originalEcpmAverage', title: '原始收入ecpm' },
        { field: "originalWinPrice", title: "原始收入" },
        { field: "profit", title: "利润" },
        { field: "profitRate", title: "利润率" },
        { field: "time", title: "时长(毫秒)" },
        { field: "dpSmt", title: "唤起数" },
        { field: "uniWinSmt", title: "竞得数" },
        { field: "bidRate", title: "竞得率" },
        { field: "cpvAverage", title: "百万请求消耗" },
      ],
      hides: [
        "originalEcpmAverage",
        "uniWinSmt",
        "bidRate",
        "dpSmt",
        "cpcPrice",
        "effectiveResSmt",
        "effectiveShowRat",
        "effectiveFillingRate",
      ],
      listData: [],
      dialogStatus: false,
      checked: false,
      slotIdList: [],
      dspSlotIdList: [],
      selectionColumn: [],
      checkDialog: false,
      chartParam: {},
      chartTimeRadio: '今天',
      checkDauData: [],
      slotIdLists: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  watch: {
    checked(val) {
      if (!val && this.dialogStatus) {
        this.chartParam.startTime2 = undefined;
        this.chartParam.endTime2 = undefined;
        this.fetchChartData();
      }
    }
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/report/channel/list";
      this.tableParams.pageNum = this.pagination.pageNum;
      this.tableParams.pageSize = this.pagination.pageSize;
      return true;
    },
    afterInit(res) {
      this.tableData = this.generateTableId(res.data.records, 0);
      // this.$nextTick(() => {
      //   this.$refs.report.doLayout()
      // })
    },
    handleDisable(row, index) {
      if (row.appId) {
        return false;
      } else {
        return true;
      }
    },
    sizeChange(e) {
      this.pagination.pageSize = e;
      this.tableParams.pageSize = e;
      this.init();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.tableParams.pageNum = e;
      this.init();
    },
    toQuery() {
      if (this.slotIdList) {
        this.tableParams.slotIdList = this.slotIdList.join(",");
      }
      if (this.dspSlotIdList) {
        this.tableParams.dspSlotIdList = this.dspSlotIdList.join(",");
      }
      this.init();
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime;
      this.tableParams.endTime = date.endTime;
    },
    changeChartDate(date) {
      this.chartParam.startTime = date.startTime;
      this.chartParam.endTime = date.endTime;
      this.fetchChartData();
    },
    changeChartDate2(date) {
      this.chartParam.startTime2 = date.startTime;
      this.chartParam.endTime2 = date.endTime;
      this.fetchChartData();
    },
    fetchChartData() {
      const search = {
        dspSlotId: this.chartParam.dspSlotId,
        desc: "reportTime",
        startTime: this.chartParam.startTime,
        endTime: this.chartParam.endTime,
      };
      if (this.checked) {
        search.contrast = true;
        search.startTime2 = this.chartParam.startTime2;
        search.endTime2 = this.chartParam.endTime2;
      }
      getDspEchartTimeReportList(search).then(res => {
        if (res.code === 200) {
          this.listData = res.data;
        }
      });
    },
    changeChartTimeRadio() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      let start = new Date(today)
      let end = new Date(today)
      const DAY_MS = 86400000

      switch (this.chartTimeRadio) {
        case '最近3天':
          start.setTime(today.getTime() - DAY_MS * 2)
          break
        case '最近7天':
          start.setTime(today.getTime() - DAY_MS * 6)
          break
        case '最近15天':
          start.setTime(today.getTime() - DAY_MS * 14)
          break
        case '本月':
          start = new Date(year, month, 1)
          end = new Date(year, month + 1, 0) // 本月最后一天
          break
        case '上月':
          start = new Date(year, month - 1, 1)
          end = new Date(year, month, 0) // 上月最后一天
          break
        default:
          start.setTime(today.getTime() - DAY_MS * 2)
      }
      this.chartParam.defaultDate = [start, end]
    },
    changeDateFormatData(dateFormatId) {
      this.dateFormatId = dateFormatId;
      this.tableParams.isDay = null;
      this.tableParams.isHour = null;
      this.tableParams.isMonth = null;
      if (dateFormatId === 0) {
        this.tableParams.isDay = 2;
        this.tableParams.isHour = 2;
        this.tableParams.isMonth = 2;
        this.tableParams.desc = "";
      } else if (dateFormatId === 1) {
        this.tableParams.isDay = 1;
        this.tableParams.desc = "reportTime";
      } else if (dateFormatId === 2) {
        this.tableParams.isHour = 1;
        this.tableParams.desc = "reportTime";
      } else if (dateFormatId === 3) {
        this.tableParams.isMonth = 1;
        this.tableParams.desc = "reportTime";
      }
      this.tableParams.asc = "";
    },
    load(tree, treeNode, resolve) {
      this.$nextTick(() => {
        const search = {
          slotId: tree.slotId,
          dspId: tree.dspId,
          budget: this.tableParams.budget,
          isDayHourMonth: this.dateFormatId,
          asc: this.tableParams.asc,
          desc: this.tableParams.desc,
        };
        if (tree.reportTime === undefined || this.dateFormatId === 3) {
          search.endTime = this.tableParams.endTime;
          search.startTime = this.tableParams.startTime;
          if (this.dateFormatId === 2 || this.dateFormatId === 3) {
            search.startTime = search.startTime + "00";
            search.endTime = search.endTime + "23";
          }
        } else {
          search.endTime = tree.reportTime;
          search.startTime = tree.reportTime;
        }
        getChannelDetailReportList(search).then((res) => {
          if (res.code === 200) {
            resolve(this.generateTableId(res.data, tree.id));
          }
        });
      });
    },
    generateTableId(data, base) {
      if (!data) return [];
      for (let i = 0; i < data.length; i++) {
        data[i].id = uuid();
        if (base === 0) {
          data[i].hasChildren = true;
        } else {
          data[i].slotId = data[i].dspSlotCode;
          data[i].slotName = data[i].dspSlotName;
          data[i].dauSlotReqSmt = data[i].dauReqSmt;
        }
      }
      return data;
    },
    sortChange(column, prop, order) {
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop;
        this.tableParams.desc = "";
      } else if (column.order === "descending") {
        this.tableParams.desc = column.prop;
        this.tableParams.asc = "";
      }
      this.init();
    },
    selectionChange(selection) {
      this.selectionColumn = selection;
    },
    down() {
      const parms = Object.assign({}, this.tableParams);
      parms.isDayHourMonth = this.dateFormatId;
      if (this.dateFormatId === 2) {
        parms.startTime = parms.startTime + "00";
        parms.endTime = parms.endTime + "23";
      }
      this.downExcel("/report/channel/detail/list/csv", "渠道明细报表", parms);
    },
    // 检查dau
    inspectDau() {
      if (this.selectionColumn.length > 0) {
        const slotIdList = [];
        this.selectionColumn.forEach((index) => {
          slotIdList.push(index.slotId);
        });
        this.slotIdLists = slotIdList.toString();
        dauInspect({
          slotIdList: this.slotIdLists,
          pageNum: this.tableParams.pageNum,
          pageSize: this.tableParams.pageSize,
          startTime: this.tableParams.startTime,
          endTime: this.tableParams.endTime,
        }).then((res) => {
          if (res.code == 200) {
            this.checkDauData = res.data;
            this.checkDialog = true;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("请先选择检查项");
      }
    },
    tableSummary(row) {
      const arr = [
        "uniShowSmt",
        "uniClkSmt",
        "reqSmt",
        "resSmt",
        "dpSmt",
        "originalWinPrice",
        "dauSlotReqSmt",
        "uniWinSmt",
        "bidPrice",
        "basePrice",
        "bidDspPrice",
        "realBidPrice",
        "realDauSmt",
      ];
      const fixedArr = ["auctionPrice", "winPrice", "profit","originalWinPrice"];
      const fixed2Arr = [
        "channelEcpm",
        "ecpmAverage",
        "originalEcpmAverage",
        "fillingRate",
        "showRat",
        "clickRate",
        "dpRate",
        "bidRate",
      ];
      const { data } = row;
      const checklists = this.checkColumns.map((item) => {
        return item.field;
      });
      checklists.unshift("0");
      if (this.tableParams.isDay === 1 || this.tableParams.isHour === 1) {
        checklists.unshift("0");
      }
      const out = [];
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = "合计";
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] = data
              .reduce((total, item) => {
                return total + Number(item[checklists[i]]);
              }, 0)
              .toFixed(4);
          } else if (fixed2Arr.indexOf(checklists[i]) > -1) {
            switch (checklists[i]) {
              case "channelEcpm":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.auctionPrice);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  1000
                ).toFixed(4);
                break;
              case "ecpmAverage":
                out[i] = (
                  (data
                    .reduce((total, item) => {
                      return total + Number(item.winPrice);
                    }, 0)
                    .toFixed(4) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  1000
                ).toFixed(2);
                break;
              case "fillingRate":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.resSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.reqSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "showRat":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniShowSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "clickRate":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniClkSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "dpRate":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.dpSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniClkSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "bidRate":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniWinSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
            }
          } else {
            out[i] =
              arr.indexOf(checklists[i]) > -1
                ? data.reduce((total, item) => {
                    return total + Number(item[checklists[i]]);
                  }, 0)
                : "-";
          }
        }
      }
      return out;
    },
    openMyEchart(data) {
      this.dialogStatus = true;
      this.chartParam.title = data.slotName;
      this.chartParam.slotId = data.slotId;
      this.chartParam.startTime = data.startTime;
      this.chartParam.endTime = data.endTime;
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
      this.chartParam.defaultDate = [start, new Date()];
    },
    close() {
      this.listData = [];
      this.chartParam = {};
      this.chartTimeRadio = '今天';
      this.dialogStatus = false;
      this.checked = false
    },
    closeCheckDialog() {
      this.checkDialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__placeholder {
  display: none;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

// /deep/.el-table__footer-wrapper tbody td{
//   border-bottom: none;
//   .cell{
//   overflow: hidden;
//   text-overflow: ellipsis;
//   word-break:normal
//   }
// }
// /deep/.el-table__fixed-footer-wrapper tbody td{
//   border-bottom: none;
//   .cell{
//       word-break:normal;
//   }
// }
// /deep/.el-table__fixed-header-wrapper .cell{
//   width: 70px;
// }
// /deep/.el-table__body-wrapper {
//   order: 0;
// }
</style>
